export default __webpack_public_path__ + "static/media/our-work.4ed4ee5a.mp4";